const RiskFilterStatus = {
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
};

const RiskFilterResultCode = {
  APPR_1000: 'APPR-1000',
  APPR_1001: 'APPR-1001',
  APPR_1010: 'APPR-1010',
  APPR_1100: 'APPR-1100',
  APPR_1011: 'APPR-1011',
  DECL_1110: 'DECL-1110',
  DECL_1101: 'DECL-1101',
  DECL_1111: 'DECL-1111',
};

module.exports = {
  RiskFilterStatus,
  RiskFilterResultCode,
};
